// extracted by mini-css-extract-plugin
export default {"trigger":"ThemeTrigger_trigger__tnt7n","trigger__button":"ThemeTrigger_trigger__button__wdKnz"};